module.exports = {
      id: "my-vikatan-logo-usage",
      viewBox: "0 0 500 200",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#my-vikatan-logo",
      toString: function () {
        return this.url;
      }
    }